import { render } from "./DataUser.vue?vue&type=template&id=dbcb98c8&scoped=true"
import script from "./DataUser.vue?vue&type=script&lang=js"
export * from "./DataUser.vue?vue&type=script&lang=js"

import "./DataUser.vue?vue&type=style&index=0&id=dbcb98c8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbcb98c8"]])

export default __exports__